import { useTranslation } from 'react-i18next';
import { useCart } from '../../../context/CartContext';
import { products } from '../../../mocks/products';

const zeep = products.find(p => p.id === 'ee-1')!;
const cologne = products.find(p => p.id === 'ee-6')!;

export const EERituelBundel = () => {
  const { t } = useTranslation();
  const { addToCart } = useCart();
  const bundlePrice = zeep.price + cologne.price;
  const originalTotal = zeep.price + cologne.price;

  const ritualSteps = [
    {
      step: '01',
      icon: 'ri-drop-line',
      title: t('ee_bundle_step1_title'),
      desc: t('ee_bundle_step1_desc'),
    },
    {
      step: '02',
      icon: 'ri-bubble-chart-line',
      title: t('ee_bundle_step2_title'),
      desc: t('ee_bundle_step2_desc'),
    },
    {
      step: '03',
      icon: 'ri-archive-line',
      title: t('ee_bundle_step3_title'),
      desc: t('ee_bundle_step3_desc'),
    },
    {
      step: '04',
      icon: 'ri-coin-line',
      title: t('ee_bundle_step4_title'),
      desc: t('ee_bundle_step4_desc'),
    },
    {
      step: '05',
      icon: 'ri-water-flash-line',
      title: t('ee_bundle_step5_title'),
      desc: t('ee_bundle_step5_desc'),
    },
  ];

  const handleAddBundle = () => {
    addToCart({ id: zeep.id, name: zeep.name, price: zeep.price, type: 'product', image: zeep.image });
    addToCart({ id: cologne.id, name: cologne.name, price: cologne.price, type: 'product', image: cologne.image });
  };

  return (
    <section id="ritueel-bundel" className="w-full py-24 bg-gradient-to-b from-[#110200] to-[#0d0000] relative overflow-hidden">

      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-red-900/10 blur-3xl pointer-events-none" />

      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 relative z-10">

        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-red-400 text-xs font-semibold uppercase tracking-widest mb-3">{t('ee_bundle_badge')}</p>
          <h2 className="text-3xl lg:text-5xl font-black text-white mb-5 leading-tight">
            {t('ee_bundle_title').split(' ').slice(0, 2).join(' ')}{' '}
            <span className="text-transparent bg-gradient-to-r from-red-400 to-orange-400 bg-clip-text">
              {t('ee_bundle_title').split(' ').slice(2).join(' ')}
            </span>
          </h2>
          <p className="text-white/45 text-sm max-w-2xl mx-auto leading-relaxed">
            {t('ee_bundle_sub')}
          </p>
        </div>

        {/* Bundle Products */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-16">

          {/* Zeep Card */}
          <div className="relative bg-[#1a0000]/70 border border-red-500/20 rounded-3xl p-6 flex gap-5 items-start overflow-hidden group">
            <div className="absolute top-4 right-4 px-2.5 py-1 bg-red-700/40 border border-red-500/30 rounded-full">
              <span className="text-red-300 text-xs font-bold">{t('ee_bundle_step1')}</span>
            </div>
            <div className="w-24 h-24 shrink-0 rounded-2xl overflow-hidden">
              <img src={zeep.image} alt={zeep.name} className="w-full h-full object-cover object-top" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-red-400/60 text-xs uppercase tracking-wider mb-1">Evil Energy Destroy</p>
              <h3 className="text-white font-black text-lg mb-2 leading-tight">{zeep.name}</h3>
              <p className="text-white/45 text-xs leading-relaxed mb-3 line-clamp-2">
                Mengsel van krachtige extracten dat evil energy actief verbreekt en vernietigt — geen synthetische toevoegingen.
              </p>
              <div className="flex items-center gap-3">
                <span className="text-red-400 font-black text-xl">€{zeep.price.toFixed(2)}</span>
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, i) => (
                    <div key={i} className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-star-fill text-orange-400 text-xs" />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Cologne Card */}
          <div className="relative bg-[#1a0000]/70 border border-red-500/20 rounded-3xl p-6 flex gap-5 items-start overflow-hidden group">
            <div className="absolute top-4 right-4 px-2.5 py-1 bg-orange-700/40 border border-orange-500/30 rounded-full">
              <span className="text-orange-300 text-xs font-bold">{t('ee_bundle_step2')}</span>
            </div>
            <div className="w-24 h-24 shrink-0 rounded-2xl overflow-hidden">
              <img src={cologne.image} alt={cologne.name} className="w-full h-full object-cover object-top" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-red-400/60 text-xs uppercase tracking-wider mb-1">Evil Energy Destroy</p>
              <h3 className="text-white font-black text-lg mb-2 leading-tight">{cologne.name}</h3>
              <p className="text-white/45 text-xs leading-relaxed mb-3 line-clamp-2">
                Voeg toe aan het badwater als basis van het ritueel — versterkt de werking van de zeep en laadt het mengsel op.
              </p>
              <div className="flex items-center gap-3">
                <span className="text-red-400 font-black text-xl">€{cologne.price.toFixed(2)}</span>
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, i) => (
                    <div key={i} className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-star-fill text-orange-400 text-xs" />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Ritual Steps */}
        <div className="bg-[#140000]/80 border border-red-500/15 rounded-3xl p-8 lg:p-12 mb-12">
          <div className="flex items-center gap-3 mb-10">
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-red-700/30 border border-red-500/20">
              <i className="ri-magic-line text-red-400 text-sm" />
            </div>
            <div>
              <h3 className="text-white font-black text-xl">{t('ee_bundle_ritual_title')}</h3>
              <p className="text-white/35 text-xs mt-0.5">{t('ee_bundle_ritual_sub')}</p>
            </div>
          </div>

          <div className="relative">
            {/* Vertical line */}
            <div className="absolute left-6 top-8 bottom-8 w-px bg-gradient-to-b from-red-500/40 via-orange-500/20 to-transparent hidden lg:block" />

            <div className="space-y-6">
              {ritualSteps.map((s, i) => (
                <div key={s.step} className="flex gap-5 items-start group">
                  {/* Step indicator */}
                  <div className="relative shrink-0">
                    <div className={`w-12 h-12 flex items-center justify-center rounded-full border transition-all ${
                      i < 2
                        ? 'bg-red-700/40 border-red-500/50'
                        : i === 2
                        ? 'bg-orange-700/30 border-orange-500/40'
                        : 'bg-[#1a0000]/60 border-red-500/20'
                    }`}>
                      <i className={`${s.icon} text-sm ${i < 2 ? 'text-red-400' : i === 2 ? 'text-orange-400' : 'text-red-400/60'}`} />
                    </div>
                    <span className="absolute -top-1 -right-1 text-red-500/50 text-xs font-black">{s.step}</span>
                  </div>

                  {/* Content */}
                  <div className="flex-1 pb-4 border-b border-red-500/8 last:border-0">
                    <h4 className="text-white font-bold text-sm mb-1">{s.title}</h4>
                    <p className="text-white/45 text-xs leading-relaxed">{s.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Ritual tip */}
          <div className="mt-8 flex gap-3 p-4 bg-red-900/15 border border-red-500/15 rounded-2xl">
            <div className="w-8 h-8 flex items-center justify-center shrink-0">
              <i className="ri-information-line text-red-400 text-base" />
            </div>
            <div>
              <p className="text-red-300/80 font-semibold text-xs mb-1">{t('ee_bundle_ritual_note')}</p>
              <p className="text-white/40 text-xs leading-relaxed">
                {t('ee_bundle_ritual_note_desc')}
              </p>
            </div>
          </div>
        </div>

        {/* Bundle CTA */}
        <div className="relative bg-gradient-to-r from-[#2a0000]/80 to-[#1a0500]/80 border border-red-500/25 rounded-3xl p-8 lg:p-12 text-center overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-red-900/5 to-orange-900/5 pointer-events-none" />

          <div className="relative z-10">
            <p className="text-red-400/70 text-xs font-semibold uppercase tracking-widest mb-3">{t('ee_bundle_cta_badge')}</p>
            <h3 className="text-white font-black text-2xl lg:text-3xl mb-2">
              {t('ee_bundle_cta_title')}
            </h3>
            <p className="text-white/40 text-sm mb-6">{t('ee_bundle_cta_sub')}</p>

            <div className="flex items-center justify-center gap-4 mb-8">
              <div className="text-center">
                <div className="flex items-center gap-2 justify-center mb-1">
                  <span className="text-white/30 text-sm line-through">€{originalTotal.toFixed(2)}</span>
                  <span className="px-2 py-0.5 bg-green-500/15 border border-green-500/20 text-green-400 text-xs font-bold rounded-full">{t('ee_bundle_label')}</span>
                </div>
                <span className="text-red-400 font-black text-4xl">€{bundlePrice.toFixed(2)}</span>
                <p className="text-white/25 text-xs mt-1">Zeep €{zeep.price.toFixed(2)} + Cologne €{cologne.price.toFixed(2)}</p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <button
                onClick={handleAddBundle}
                className="inline-flex items-center gap-2 px-10 py-4 bg-gradient-to-r from-red-700 to-orange-700 text-white font-black text-base rounded-full hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-shopping-cart-line" />
                </div>
                {t('ee_bundle_add')}
              </button>
              <a
                href="#producten"
                className="inline-flex items-center gap-2 px-8 py-4 bg-white/5 border border-white/15 text-white/70 font-semibold text-sm rounded-full hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap"
              >
                {t('ee_bundle_all')}
              </a>
            </div>

            <div className="flex flex-wrap justify-center gap-6 mt-8 text-white/25 text-xs">
              <span className="flex items-center gap-1.5">
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-shield-check-line text-red-500/60" />
                </div>
                {t('ee_bundle_pure')}
              </span>
              <span className="flex items-center gap-1.5">
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-recycle-line text-red-500/60" />
                </div>
                {t('ee_bundle_daily')}
              </span>
              <span className="flex items-center gap-1.5">
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-award-line text-red-500/60" />
                </div>
                {t('ee_bundle_proven')}
              </span>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};
